export abstract class BaseResponse {
  ErrorCode?: any;
  IsError?: boolean;
  result?: number;
  message?: string;
  data?: any;
  literalMessage?: string;
}



// WEBPACK FOOTER //
// ./src/app/response/internal/baseresponse.ts